/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "../models";
import * as Mappers from "../models/documentMappers";
import * as Parameters from "../models/parameters";
import { PolandPharmacyRxAPIContext } from "../polandPharmacyRxAPIContext";

/** Class representing a Document. */
export class Document {
  private readonly client: PolandPharmacyRxAPIContext;

  /**
   * Create a Document.
   * @param {PolandPharmacyRxAPIContext} client Reference to the service client.
   */
  constructor(client: PolandPharmacyRxAPIContext) {
    this.client = client;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<Models.DocumentAllForPharmacyResponse>
   */
  allForPharmacy(options?: Models.DocumentAllForPharmacyOptionalParams): Promise<Models.DocumentAllForPharmacyResponse>;
  /**
   * @param callback The callback
   */
  allForPharmacy(callback: msRest.ServiceCallback<Models.SourceDocumentDtoPagedResult>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  allForPharmacy(options: Models.DocumentAllForPharmacyOptionalParams, callback: msRest.ServiceCallback<Models.SourceDocumentDtoPagedResult>): void;
  allForPharmacy(options?: Models.DocumentAllForPharmacyOptionalParams | msRest.ServiceCallback<Models.SourceDocumentDtoPagedResult>, callback?: msRest.ServiceCallback<Models.SourceDocumentDtoPagedResult>): Promise<Models.DocumentAllForPharmacyResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      allForPharmacyOperationSpec,
      callback) as Promise<Models.DocumentAllForPharmacyResponse>;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<Models.DocumentAllResponse>
   */
  all(options?: Models.DocumentAllOptionalParams): Promise<Models.DocumentAllResponse>;
  /**
   * @param callback The callback
   */
  all(callback: msRest.ServiceCallback<Models.SourceDocumentDtoPagedResult>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  all(options: Models.DocumentAllOptionalParams, callback: msRest.ServiceCallback<Models.SourceDocumentDtoPagedResult>): void;
  all(options?: Models.DocumentAllOptionalParams | msRest.ServiceCallback<Models.SourceDocumentDtoPagedResult>, callback?: msRest.ServiceCallback<Models.SourceDocumentDtoPagedResult>): Promise<Models.DocumentAllResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      allOperationSpec,
      callback) as Promise<Models.DocumentAllResponse>;
  }

  /**
   * @param id
   * @param [options] The optional parameters
   * @returns Promise<Models.DocumentGetByIdResponse>
   */
  getById(id: string, options?: msRest.RequestOptionsBase): Promise<Models.DocumentGetByIdResponse>;
  /**
   * @param id
   * @param callback The callback
   */
  getById(id: string, callback: msRest.ServiceCallback<any>): void;
  /**
   * @param id
   * @param options The optional parameters
   * @param callback The callback
   */
  getById(id: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<any>): void;
  getById(id: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<any>, callback?: msRest.ServiceCallback<any>): Promise<Models.DocumentGetByIdResponse> {
    return this.client.sendOperationRequest(
      {
        id,
        options
      },
      getByIdOperationSpec,
      callback) as Promise<Models.DocumentGetByIdResponse>;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<Models.DocumentGetZippedByIdResponse>
   */
  getZippedById(options?: Models.DocumentGetZippedByIdOptionalParams): Promise<Models.DocumentGetZippedByIdResponse>;
  /**
   * @param callback The callback
   */
  getZippedById(callback: msRest.ServiceCallback<any>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getZippedById(options: Models.DocumentGetZippedByIdOptionalParams, callback: msRest.ServiceCallback<any>): void;
  getZippedById(options?: Models.DocumentGetZippedByIdOptionalParams | msRest.ServiceCallback<any>, callback?: msRest.ServiceCallback<any>): Promise<Models.DocumentGetZippedByIdResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getZippedByIdOperationSpec,
      callback) as Promise<Models.DocumentGetZippedByIdResponse>;
  }
}

// Operation Specifications
const serializer = new msRest.Serializer(Mappers);
const allForPharmacyOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "portal/document/Document",
  queryParameters: [
    Parameters.filters,
    Parameters.sorts,
    Parameters.page,
    Parameters.pageSize,
    Parameters.documentCategory
  ],
  responses: {
    200: {
      bodyMapper: Mappers.SourceDocumentDtoPagedResult
    },
    default: {}
  },
  serializer
};

const allOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "document/Document",
  queryParameters: [
    Parameters.filters,
    Parameters.sorts,
    Parameters.page,
    Parameters.pageSize,
    Parameters.documentCategory
  ],
  responses: {
    200: {
      bodyMapper: Mappers.SourceDocumentDtoPagedResult
    },
    default: {}
  },
  serializer
};

const getByIdOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "document/Document/{id}",
  urlParameters: [
    Parameters.id1
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Stream"
        }
      }
    },
    400: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "String"
        }
      }
    },
    default: {}
  },
  serializer
};

const getZippedByIdOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "document/Document/zipped",
  queryParameters: [
    Parameters.id2,
    Parameters.zipExtension
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Stream"
        }
      }
    },
    400: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "String"
        }
      }
    },
    default: {}
  },
  serializer
};
